/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { configDTO } from './envs/env';

Sentry.init({
  dsn: configDTO.sentry.dsn,
  debug: configDTO.sentry.debug,
  release: configDTO.appVersion,
  environment: configDTO.env,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: configDTO.sentry.replaysMaskAllText,
      maskAllInputs: configDTO.sentry.replaysMaskAllInputs,
      blockAllMedia: configDTO.sentry.replaysBlockAllMedia,
    }),
  ],
  replaysSessionSampleRate: configDTO.sentry.replaysSessionSampleRate,
  replaysOnErrorSampleRate: configDTO.sentry.replaysOnErrorSampleRate,
  tracesSampleRate: configDTO.sentry.tracesSampleRate,
  tracePropagationTargets: configDTO.sentry.tracePropagationTargets,
});

bootstrapApplication(AppComponent, appConfig).catch((error: unknown): void =>
  console.error(error)
);
